var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.c5f66963bde87bc87a2394392c962f8b.svg#w';
                    var viewUrl = 'sprites.c5f66963bde87bc87a2394392c962f8b.svg#view-w';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 22 23',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };